import Logo from '@Components/UI/Logo/Logo';
import Divider from './Divider/Divider';
import styles from './Footer.module.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as FacebookSvg } from '@Assets/svg/faceBook.svg';
import { ReactComponent as InstagramSvg } from '@Assets/svg/instagram.svg';
import { ReactComponent as WhatsappSvg } from '@Assets/svg/whatsapp.svg';
import { ReactComponent as LinkedinSvg } from '@Assets/svg/linkedin.svg';

interface FooterProps {
	className?: string;
}

const Footer = ({ className = '' }: FooterProps) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<footer className={`${className} ${styles.main_container}`}>
			<div className={styles.container}>
				<div className={styles.header}>
					<Logo className={styles.footer_logo} onClick={() => navigate('/home')} />
					<div className={styles.footer_social_icons}>
						<a href="https://www.facebook.com/wiautorent" target="_blank" rel="noopener noreferrer" className={styles.link}>
							<FacebookSvg className={styles.fb_icon} />
						</a>
						<a
							href="https://www.instagram.com/wifinance.srl/"
							target="_blank"
							rel="noopener noreferrer"
							className={styles.link}
						>
							<InstagramSvg className={styles.ig_icon} />
						</a>
						<a
							href="https://www.linkedin.com/showcase/wifinance-autorent"
							target="_blank"
							rel="noopener noreferrer"
							className={styles.link}
						>
							<LinkedinSvg className={styles.in_icon} />
						</a>
						<a href="whatsapp://send?phone=393500768160" target="_blank" rel="noopener noreferrer" className={styles.link}>
							<WhatsappSvg className={styles.wa_icon} />
						</a>
					</div>
				</div>

				<Divider className={styles.footer_divider} />

				<div className={styles.contatti_container}>
					<div className={styles.col_contatti}>
						<div className={styles.contatti_div}>{t('footer.contacts')}</div>
						<div>
							<a className={styles.link_label} href="tel:051 887512">
								+39 051 887512
							</a>
						</div>
						<div>
							<a className={styles.link_label} href="mailto:info@wiautorent.it">
								info@wiautorent.it
							</a>
						</div>
						<div>
							<a className={styles.link_label} href="https://www.wifinance.it/">
								wifinance.it
							</a>
						</div>
					</div>
					<div className={styles.col_societa}>
						<div className={styles.societa_div}>{t('footer.companyInfo')}</div>
						<div>
							<a
								className={styles.link_label}
								href="https://maps.google.com/?q=Via%20Bentivogli,%206%20-%2040062%20%20Molinella%20(BO)%40062"
							>
								Molinella (BO)
							</a>
						</div>
						<div>
							<a
								className={styles.link_label}
								href="https://maps.google.com/?q=Via%20Bentivogli,%206%20-%2040062%20%20Molinella%20(BO)"
							>
								Via Bentivogli, 6
							</a>
						</div>
						<div className={styles.link_label}>{t('footer.vat')}</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
